import { createLookup, createMap } from "@omnia/shared/utils/array"
import { GenplanLayer } from "../../map/genplanLayer"
import { defineComponent, FieldViewModel, IGenericPlan, IOmniaSession, IParam, LayerTypeId, LocaleString, param } from "../../omnia"
import { IDatalayersService } from "../../types"
import { IGenericPlanContext } from "../types"
import { GenericPlanContext } from "./context"
import { isResourceAccessible } from "@omnia/shared/permissions/holding/accessRestrictions"

export type Plan = Readonly<Partial<IGenericPlan>>

export class GenericPlanCtrl {

    static create(): ng.IDirective {

        return defineComponent(GenericPlanCtrl, "app/datalayers/edit/genplan/genplan.html", {
            layer: "=",
            context: "="
        })

    }

    context: IGenericPlanContext

    public layer: GenplanLayer

    public plans: Plan[]
    private _plan: Plan

    public units: IParam[]

    static $inject = ["$scope", "OmniaDatalayersService"]

    constructor(private $scope: ng.IScope, private svc: IDatalayersService) {
    }


    $onInit() {

        this.units = param.GenericPlanUnitId()

        const { svc } = this
        const session = svc.getSession()

        svc.getHoldingLayers([LayerTypeId.GenericPlan])
            .then(layers => {

                const cropping = svc.cropping.filter(c => c.yearId)

                let plans = this.svc.getGenericPlans(this.svc.yearId)

                plans = filterAuthorizedPlans(session, plans, layers, cropping)

                this.setupPlans(plans)

                this.plan = this.layer ? this.layer.plan : undefined

            })

    }

    private setupPlans(plans: IGenericPlan[]) {

        this.plans = [
            {
                GenericPlanId: 0,
                Name: "(Create a new plan)" as LocaleString
            }
        ].concat(plans)
    }


    get plan() {
        return this._plan
    }

    set plan(plan) {
        this._plan = plan
        this.context = plan
            ? new GenericPlanContext(plan, this.layer)
            : undefined
        this.updateUnits()
    }

    updateUnits() {
        this.layer.setUnits(this.context ? this.context.units : undefined)
    }

}


/**
 * Filters a set of plans based on its layers' cropping
 */
function filterAuthorizedPlans(session: IOmniaSession, plans: IGenericPlan[], layers: { GenericPlanId?: number, CroppingId?: number }[], cropping: FieldViewModel[]): IGenericPlan[] {

    const layersLookup = createLookup(layers, l => l.GenericPlanId ?? 0)
    const croppingMap = createMap(cropping, c => c.croppingId)

    plans = plans.filter(plan => {

        if (!isResourceAccessible(session, plan)) {
            return false
        }

        const layers = layersLookup[plan.GenericPlanId] ?? []

        return layers.some(l => {
            const cropping = croppingMap.get(l.CroppingId ?? 0)
            return cropping?.authorized ?? true
        })

    })

    return plans

}

